import {
  AXIS_FONT_SIZE_PX,
  AXIS_FONT_WEIGHT_BOLD,
  AXIS_FONT_WEIGHT_REGULAR,
} from "../constants";

/**
 * CSS font of axis labels.
 *
 * @param {string} fontFamily
 * @param {boolean} [isBold]
 * @returns {string}
 */
export const axisFont = (fontFamily, isBold = false) =>
  `${isBold ? AXIS_FONT_WEIGHT_BOLD : AXIS_FONT_WEIGHT_REGULAR} ${AXIS_FONT_SIZE_PX}px ${fontFamily}`;
